import React from 'react';
import { SalesPage } from './pages/SalesPage';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="w-full min-h-screen bg-black" data-id="element-1">
        <SalesPage data-id="element-2" />
      </div>
    </LanguageProvider>;
}